import { BarChart2 } from 'lucide-react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

interface DepartmentMetrics {
  department: string;
  responses: number;
  invitations: number;
  completion_rate: number;
}

interface DepartmentResponseChartProps {
  data: DepartmentMetrics[];
}

export function DepartmentResponseChart({ data }: DepartmentResponseChartProps) {
  // Ensure completion rates are capped at 100%
  const normalizedData = data.map(item => ({
    ...item,
    completion_rate: Math.min(item.completion_rate, 100) // Cap at 100%
  }));

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
      <div className="flex items-center mb-4">
        <BarChart2 className="h-5 w-5 text-blue-500 dark:text-blue-400" />
        <h2 className="ml-2 text-lg font-semibold text-gray-900 dark:text-white">Department Response Rates</h2>
      </div>
      <div className="h-[300px] w-full">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={normalizedData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
            <XAxis 
              dataKey="department" 
              stroke="#9CA3AF"
              tick={{ fill: '#9CA3AF', fontSize: 12 }}
              interval={0}
              angle={-45}
              textAnchor="end"
              height={100}
            />
            <YAxis 
              stroke="#9CA3AF"
              tick={{ fill: '#9CA3AF', fontSize: 12 }}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: '#1F2937',
                border: 'none',
                borderRadius: '0.375rem',
                color: '#F3F4F6',
                fontSize: '12px'
              }}
            />
            <Legend 
              wrapperStyle={{
                paddingTop: '20px',
                fontSize: '12px'
              }}
            />
            <Bar
              dataKey="responses"
              name="Total Responses"
              fill="#3B82F6"
              radius={[4, 4, 0, 0]}
            />
            <Bar
              dataKey="completion_rate"
              name="Completion Rate (%)"
              fill="#10B981"
              radius={[4, 4, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}